export const featureFlags = {
    /**
     * Admin banner moderation dashboard visibility.
     *
     * - false: route is available to all authenticated users (for rollout / QA).
     * - true: only admin users can see the route.
     */
    adminBannerModeration: true,

    /**
     * Show cart button in the top navbar (when logged in).
     */
    showCartButton: false,

    /**
     * Show price mode selector (fixed price vs negotiable) on the /additem (sell) form.
     */
    showPriceModeInAddItem: false
} as const;

